// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/order
import React from 'react';
import GooglePlacesAutocomplete from 'react-google-places-autocomplete';
// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/order
import styled from 'styled-components';
import { StyledMobileBoxItemRow } from '../../../utils/Styles/DataBoxStyles';

const StyledSearchBoxWrapper = styled.div`
    position: ${props => (props.isMobileView ? 'static' : 'absolute')};
    width: 35%;
    min-width: 300px;
    
    left: ${props => (props.isMobileView ? '0' : '10px')}
    top: ${props => (props.isMobileView ? '0' : '4%')}
    z-index: 1;
   
`;

const ActivityLocationSearchBox = ({
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line react/prop-types
  apiKey,
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line react/prop-types
  value,
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line react/prop-types
  onChange,
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line react/prop-types
  isMobileView,
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line react/prop-types
  isMobileEditMode,
}) => {
  return (
    <StyledSearchBoxWrapper isMobileView={isMobileView}>
      {isMobileView ? (
        <StyledMobileBoxItemRow maxWidth='100%' style={{ display: 'block' }}>
          Location:
          {isMobileEditMode ? (
            <GooglePlacesAutocomplete
              apiKey={apiKey}
              selectProps={{
                defaultValue: value,
                defaultInputValue: value,
                onChange,
              }}
            />
          ) : (
            <span>{value}</span>
          )}
        </StyledMobileBoxItemRow>
      ) : (
        <GooglePlacesAutocomplete
          apiKey={apiKey}
          selectProps={{
            defaultValue: value,
            defaultInputValue: value,
            onChange,
          }}
        />
      )}
    </StyledSearchBoxWrapper>
  );
};

export default ActivityLocationSearchBox;
